module.exports = __webpack_public_path__ + "static/media/new-multiple-choice-question-pink.67fdf4dd.svg";